var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(-628 -146)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(634 146)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(628 146)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(640 146)",
    fill: "#707070"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.50429c96db08a3d98b3868559a376da2.svg";
export { ForwardRef as ReactComponent };